export default __webpack_public_path__ + "static/media/Advanced Contextual logo vertical.07c6da3c.png";